import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useLocation } from "react-router-dom";

import Button from "../../../../components/UI/Button/Button";
import Form from "/src/components/form/Form";
import Field from "/src/components/UI/Field/Field";
import TextInput from "/src/components/UI/TextField/TextInput";
import logo from "/src/assets/img/png/logo_black_empty.png";
import InputBox from "/src/components/UI/InputBox/InputBox";
import "./AuthForm.css";

import { useAuthDispatchContext } from "/src/features/auth/context/authContext";
import authAction from "/src/features/auth/actions/authAction";
import { useToastDispatchContext } from "/src/layouts/toast/context/toastContext";
import Slider, { Slide, ScrollIntoSlide } from "/src/components/slider/sliderView";
import urlWithRoutingCompany from "/src/utils/urlWithRoutingCompany";
import auth from "../../services/auth";
import Storage from "/src/utils/storage";

function AuthForm() {
    const { register, handleSubmit, watch, formState: { errors }, formState, setValue, getValues, } = useForm({
        mode: "onChange",
        defaultValues: { email: "", password: "" },
    });

    const [delayAuth, setDelayAuth] = useState(true);
    const [delayPasswordForgotten, setDelayDelayPasswordForgotten] = useState(true);
    const { updatePassword } = auth;
    const authDispatchContext = useAuthDispatchContext();
    const toast = useToastDispatchContext();

    const navigate = useNavigate();
    const redirectAfterLogin = useLocation().state?.from || "/supervision/conversations/list";
    const onSubmit = async (data) => {
        data.user_data = true; 
        const result = await authAction.signIn(authDispatchContext, data);
        if (delayAuth == false) return;

        if (result?.error && result.status === 403) {
            toast.error(
                "Password Renewed",
                "Your last login was more than 6 months ago. A new password has been sent to your email.",
                6000
            );
            return;
        }
        if (result?.error) {
            setDelayAuth(false);
            toast.error(
                "Authentication Error",
                "Your login information does not match any of our users",
                4000
            );
            setTimeout(() => setDelayAuth(true), 4000);
            return;
        }

        toast.success("Authentification Success", "Congratulations you are now logged to the application");
        setTimeout(() => navigate(redirectAfterLogin), 250);
    };

    const changePassword = async () => {
        if (delayPasswordForgotten == false) return;
        let dataToSend = { email: getValues("email_password_change") };
        let mess = "Perfect ! You will receive an email with a new temporary password if the email given exist";
        const [result, error] = await updatePassword(dataToSend);
        toast.success("Password Edit", mess);
        setDelayDelayPasswordForgotten(false);
        setTimeout(() => setDelayDelayPasswordForgotten(true), 4000);
    };
    const [activeSession, setActiveSession] = useState(false);
    const [readCgu, setReadCgu] = useState(true);

    return (
        <Form className="login" onSubmit={handleSubmit(onSubmit)} onClick={() => { this.disabled = true; }}>
            <Form.Title>
                <img src={logo} alt="" className="logo" />
            </Form.Title>
            <Form.Body className="body-reseize">
                <Slider>
                    <Slide name="login">
                        <h1 style={{ marginTop: 0 }}>Connexion</h1>
                        <div className="login-part">
                            <Field label={"Login"} listLabelClassName="titles-input">
                                <TextInput
                                    {...register("email", { required: true })}
                                    style={errors.email ? { borderColor: "red" } : {}}
                                />
                            </Field>
                            <Field label={"Password"} listLabelClassName="titles-input">
                                <TextInput type="password" {...register("password", { required: true })} />
                            </Field>
                            <span style={{ display: "flex" }}>
                                <Field label="Keep an active session" listClassName="read_cgu_container" listLabelClassName={"read_cgu_label title-weigth"}> {" "} </Field>
                                <span>
                                    <InputBox id="session_active" name="session_active" setValue={(name, checked) => setActiveSession(!checked)} check={true}></InputBox>
                                </span>
                            </span>

                            <span style={{ display: "flex" }}>
                                <Field
                                    label="Accept CGU "
                                    listClassName="read_cgu_container"
                                    listLabelClassName={"read_cgu_label title-weigth"}>
                                    {" "}
                                </Field>
                                <InputBox id="gcu_button" name="gcu_button" setValue={(name, checked) => { setReadCgu(checked); }} check={true}></InputBox>
                            </span>
                        </div>
                        
                        <Button type="submit" label="Login" className="validate full-width" disabled={formState.isValid == true && delayAuth == true && readCgu == true ? false : true} />
                        
                        { /* 
                        <span className="switch-section-container">
                            <a className="switch-section-text" onClick={() => ScrollIntoSlide("password-forgotten")}>
                                Password Forgotten ?
                            </a>
                        </span>
                        */}
                    </Slide>
                    { /*
                    <Slide name="password-forgotten">
                        <h2 className="ivy-h1">Password Forgotten</h2>
                        <div className="change-password-form">
                            <Field label={<span>Email</span>} listLabelClassName="titles-input">
                                <TextInput
                                    {...register("email_password_change", { pattern: /^\S+@\S+$/i })}
                                    style={errors.email_password_change ? { borderColor: "red" } : {}}
                                />
                            </Field>
                        </div>
                        <Button label="Ask new password" onClick={() => changePassword()} className="validate full-width" id="change-password-button"
                            disabled={
                                watch("email_password_change")?.length >= 3 &&
                                    errors.email_password_change == null &&
                                    delayPasswordForgotten == true
                                    ? false
                                    : true
                            }
                        />
                        <span className="switch-section-container">
                            <a className="switch-section-text" onClick={() => ScrollIntoSlide("login")}>
                                Back
                            </a>
                        </span>
                    </Slide>
                    */}
                </Slider>
            </Form.Body>
            <Form.Buttons>
                <a href="https://www.talkr.ai/rgpd/" target="_blank" style={{ color: "var(--main)" }}>
                    Legal information
                </a>
            </Form.Buttons>
        </Form>
    );
}
export default AuthForm;
